module.exports = __webpack_public_path__ + "img/casbee-pulldown-default.5f01e0f4.svg";